import { render, staticRenderFns } from "./TabProfitLoss.vue?vue&type=template&id=02565a96&scoped=true"
import script from "./TabProfitLoss.vue?vue&type=script&lang=js"
export * from "./TabProfitLoss.vue?vue&type=script&lang=js"
import style0 from "./TabProfitLoss.vue?vue&type=style&index=0&id=02565a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02565a96",
  null
  
)

export default component.exports